import { render } from "./app-form-payment-method.vue?vue&type=template&id=b3617ab6"
import script from "./app-form-payment-method.vue?vue&type=script&lang=js"
export * from "./app-form-payment-method.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/reference/app-form-payment-method.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b3617ab6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b3617ab6', __exports__)) {
    console.log('reload')
    api.reload('b3617ab6', __exports__)
  }
  
  module.hot.accept("./app-form-payment-method.vue?vue&type=template&id=b3617ab6", () => {
    console.log('re-render')
    api.rerender('b3617ab6', render)
  })

}


export default __exports__